export default "__VITE_ASSET__CmcvyWYh__"